export const ungroupedLabel = '[Others]'

export const internalGroupKeys = {
  MATCHES: '_matches',
  TOTAL_COUNT: '_totalCount',
  LABEL_KEY: '_labelKey',
}

export const greyColorLevels = ['#f1f1f1', '#e3e3e3', '#e6e6e6']
